module.exports = "<p>no-access works!</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/no-access/no-access.component.html
// module id = ../../../../../src/app/no-access/no-access.component.html
// module chunks = main